import { Component, HostListener, OnInit } from '@angular/core';
import { UtilsService } from 'app/services/utils.service';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { FooterListResource } from 'app/models/FooterListResource';
import { FooterResource } from 'app/models/FooterResource';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'vbn-footer-list',
  templateUrl: './footer-list.component.html',
  styleUrls: ['./footer-list.component.scss']
})
export class FooterListComponent implements OnInit {

  userEmail: string;
  errorMessage: any;
  footerList: FooterListResource;

  isOnResponsive: boolean = false;
  innerWidth:number;
  constructor(private service: UtilsService,
    private router: Router,
    private _notificationService: NotificationsService,
    private translate: TranslateService,) {
    this.footerList = new FooterListResource();
    this.footerList.footerList = new Array<FooterResource>();
    this.innerWidth= window.innerWidth;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth= window.innerWidth;
    if (this.innerWidth <= 1300) {
      this.isOnResponsive = true;
      for (let i = 0; i < this.footerList.footerList.length; i++) {
        this.footerList.footerList[i].showDetailsOnResponsive = false;
      }
    }
    else {
      this.isOnResponsive = false;
      for (let i = 0; i < this.footerList.footerList.length; i++) {
        this.footerList.footerList[i].showDetailsOnResponsive = true;
      }
    }
  }

  ngOnInit() {
    this.userEmail = this.service.currentUserEmail;
    this.getFootersForUser();
   
  }

  getFootersForUser(): void {
    this.service.get(`admin/footer/getFooterList?userEmail=${this.userEmail}`)
      .subscribe(
        response => {
          this.footerList = response;
          if (this.innerWidth <= 1300) {
            console.log("innerWidth---",this.innerWidth)
            this.isOnResponsive = true;
            for (let i = 0; i < this.footerList.footerList.length; i++) {
              this.footerList.footerList[i].showDetailsOnResponsive = false;
            }
          }
          else {
            for (let i = 0; i < this.footerList.footerList.length; i++) {
              this.footerList.footerList[i].showDetailsOnResponsive = true;
            }
            this.isOnResponsive = false;
          }
        },
        error => this.errorMessage = <any>error);
  }

  delete(rid) {
    this.service.get(`admin/footer/deleteOne?id=${rid}`)
      .subscribe(
        response => {
          forkJoin(
            [this.translate.get('Success'),
            this.translate.get('Footer was deleted!')]
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })

          this.getFootersForUser();
        },
        error => this.errorMessage = <any>error);
  }



  edit(rid) {
    this.router.navigate(['/edit-footer/' + btoa('{ "footerRid" : "' + rid + '"}')]);
  }

  showResponsiveDetails(id) {
    const width = window.innerWidth;
    if (width <= 1300) {
      for (let i = 0; i < this.footerList.footerList.length; i++) {
        if (this.footerList.footerList[i].rid == id) {
          this.footerList.footerList[i].showDetailsOnResponsive = !this.footerList.footerList[i].showDetailsOnResponsive;
        }
        else {
          this.footerList.footerList[i].showDetailsOnResponsive = false;
        }
      }
    }
    else {
      return;
    }

  }
}
